<template>
  <el-dialog :visible.sync="visible" :width="width" :close-on-click-modal="false" :show-close="false"
    custom-class="welcome-dialog">
    <div class="p-4">
      <div class="flex flex-col items-center text-center mb-6">
        <div class="text-6xl mb-4 rounded-full bg-purple-50 flex items-center justify-center w-24 h-24">👋</div>
        <h1 class="text-3xl font-bold mb-2">
          ¡Bienvenido a Samii! 👋
        </h1>
        <p class="text-gray-500">
          En menos de 2 minutos tendrás tu primera orden<br />
          creada y tu taller listo para usar.
        </p>
      </div>

      <div class="flex flex-col items-center">
        <el-button type="primary" size="large" class="w-full font-bold" @click="proceed">
          👉 Crear mi primera orden
        </el-button>
        <label class="text-sm text-gray-500 mt-3">
          Empieza ahora y organiza tu negocio
        </label>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SecondStepOnboarding',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    width: {
      type: String,
      default: '500px',
    },
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.skip();
        }
      },
    },
  },
  methods: {
    proceed() {
      this.$emit('proceed');
    },
    skip() {
      this.$emit('skip');
    },
  },
};
</script>

<style scoped>
/deep/ .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.welcome-dialog.el-dialog {
  border-radius: 12px;
  margin: 0 !important;
  top: 0 !important;
}

.welcome-dialog .el-dialog__header {
  display: none;
}

.welcome-dialog .el-dialog__body {
  padding: 0;
}
</style>
